import { render, staticRenderFns } from "./shoppingCart-item.vue?vue&type=template&id=2145151e&scoped=true&"
import script from "./shoppingCart-item.vue?vue&type=script&lang=js&"
export * from "./shoppingCart-item.vue?vue&type=script&lang=js&"
import style0 from "./shoppingCart-item.vue?vue&type=style&index=0&id=2145151e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2145151e",
  null
  
)

export default component.exports